<template>
  <a-form
      ref="detailForm"
      :model="detail"
      :label-col="{ span: 4 }"
      :wrapper-col="{ span: 18 }"
  >
    <a-form-item
        :label="$t('completeTime')"
        name="completetime"
        :rules="[{ required: true, message: $t('pleaseEnter') + $t('completeTime') }]"
    >
      <a-date-picker v-model:value="detail.completetime" style="width: 100%" :disabled="!canEdit"/>
    </a-form-item>
    <a-form-item
        :label="$t('annex')"
    >
      <cibr-file-upload :detail-id="detail.id" @fileChange="fileChange" :disabled="!canEdit"></cibr-file-upload>
    </a-form-item>
    <a-form-item
        :label="$t('remark')"
    >
<!--      <a-textarea v-model:value="detail.remark" :rows="4" :disabled="!canEdit"/>-->
      <comment-edit :default-html="detail.remark" @changeHtml="changeRemark" v-if="canEdit"/>
      <div v-else v-html="detail.remark"></div>
    </a-form-item>
  </a-form>
  <div style="width: 100%;text-align: center;height: 50px" v-if="canEdit">
    <a-checkbox v-model:checked="sendEmail" >
      {{ $t("sendEmail") }}
    </a-checkbox>
  </div>
  <div style="width: 100%;text-align: center">
    <a-button type="primary" v-if="canEdit && currentStatus" @click="submitDetail('next')">{{
        $t("nextStep")
      }}
    </a-button>
    <a-button v-if="canEdit" @click="realSubmit('save')">{{ $t("save") }}</a-button>
    <restart-task v-if="canEdit && !currentStatus" :task-id="taskId" :status="status" @restart="restart"></restart-task>
  </div>
  <v-loading :show="loading"></v-loading>
</template>

<script>
// zhouhan@cibr.ac.cn 2022/11/14 13:44
import VLoading from "@/components/public/v-loading";
import util from "@/util/util";
import dayjs from "dayjs";
import CibrFileUpload from "@/components/public/cibrFileUpload";
import RestartTask from "@/components/task/restartTask";
import CommentEdit from "@/components/public/commentEdit";

export default {
  name: "taskStatus",
  components: {CommentEdit, RestartTask, CibrFileUpload, VLoading},
  props: {
    taskId: String,
    status: String
  },
  data() {
    return {
      loading: false,
      sendEmail: false,
      detail: {
        id: util.getUUID(),
        fileList: [],
      },
      task: {
        status: ''
      },
    }
  },
  mounted() {
    console.log(111111)
    this.initPage();
  },
  methods: {
    changeRemark(html){
      this.detail.remark = html;
    },
    restart() {
      this.$emit("restart")
    },
    submitDetail(flag) {
      this.$refs.detailForm.validate().then(() => {
        this.realSubmit(flag)
      })
    },
    realSubmit(flag){
      this.detail.taskid = this.taskId;
      this.detail.status = this.status;
      var post = {
        detail: JSON.stringify(this.detail),
        flag: flag,
        sendEmail : this.sendEmail
      }
      util.$post("/task/detail/next", post, () => {
        if (flag === "next") {
          this.$emit("changeStatus")
        }
        // this.initPage();
      }, this.showMask, this.hideMask);
    },
    fileChange(params) {
      this.detail.fileList = params.fileList;
    },
    showMask() {
      this.loading = true;
    },
    hideMask() {
      this.loading = false;
    },
    initPage() {
      this.detail = {
        id: util.getUUID(),
        fileList: []
      }
      var post = {
        taskId: this.taskId,
        status: this.status
      }
      util.$post("/task/detail/statusInit", post, (res) => {
        if (!util.isNull(res.detail)) {
          if (!util.isNull(res.detail.completetime)){
            res.detail.completetime = dayjs(res.detail.completetime)
          }
          this.detail = res.detail;
        }
        this.task = res.task;
      }, this.showMask, this.hideMask);
    },
  },
  watch: {
    status() {
      this.initPage();
    },
    taskId() {
      this.initPage();
    }
  },
  computed: {
    canEdit() {
      return this.$store.getters.isGeneticAdmin && this.task.completestatus !== "90" && this.task.completestatus !== "91";
    },
    currentStatus() {
      return this.task.status === this.status
    }
  }
}
</script>

<style scoped>
button {
  margin: 0 5px;
}
</style>